module.exports = __webpack_public_path__ + "img/chevron-down-small.d9d96ea3.svg";